import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  phone: "+351 000 000 000",
  whatsapp: "351000000000",
  email: "geral@solutioncarpremium.pt",
  address: "Morada do stand — a definir",
  facebook: "https://facebook.com/",
  instagram: "https://instagram.com/",
  linkedin: "https://linkedin.com/",
  about_title: "",
  about_text: "",
  about_images: [],
  testimonials_title: "",
  testimonials_description: "",
  gallery_title: "",
  gallery_description: "",
  gallery_items: [],
  privacy_policy_text: "",
  privacy_policy_version: "1.0",
  data_retention_days: 365,
  legal_docs: {},
};

export function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((res) => {
        const d = res.data || {};
        setSettings((s) => ({
          ...s,
          phone: d.phone || s.phone,
          whatsapp: d.whatsapp || s.whatsapp,
          email: d.email || s.email,
          address: d.address || s.address,
          facebook: d.facebook || s.facebook,
          instagram: d.instagram || s.instagram,
          linkedin: d.linkedin || s.linkedin,
          about_title: d.about_title || "",
          about_text: d.about_text || "",
          about_images: Array.isArray(d.about_images) ? d.about_images : [],
          testimonials_title: d.testimonials_title || "",
          testimonials_description: d.testimonials_description || "",
          gallery_title: d.gallery_title || "",
          gallery_description: d.gallery_description || "",
          gallery_items: Array.isArray(d.gallery_items) ? d.gallery_items : [],
          privacy_policy_text: d.privacy_policy_text || "",
          privacy_policy_version: d.privacy_policy_version || "1.0",
          data_retention_days: d.data_retention_days || 365,
          legal_docs: d.legal_docs && typeof d.legal_docs === "object" ? d.legal_docs : {},
        }));
      })
      .catch(() => {});
  }, []);

  return settings;
}
